import React, { useState } from 'react'
import { createInitials } from '../../utils/functions/createInitials'
import ReactModal from 'react-modal'
import EditAgentOperatorProfile from '../../shared/EditAgentOperatorProfile'

interface IProps {
  data: any
}

const AgentOperatorProfilePage: React.FC<IProps> = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const openModal = () => {
    setIsModalOpen(true)
  }

  const afterOpenModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-40%, -50%)',
      border: 'none',
      borderRadius: '15px',
      boxShadow: '0 2px 8px 0 #00000029'
    }
  }

  const { label, state } = createInitials(data?.getUserById?.name)
  return (
    <>
      <div className='row gutters-sm'>
        <div className='col-md-4 mb-3'>
          <div className='card'>
            <div className='card-body py-5'>
              <div className='d-flex flex-column align-items-center text-center'>
                {' '}
                <div>
                  <div className='symbol ps-1 symbol-150px symbol-circle me-3'>
                    <span
                      className={`symbol-label bg-light-${state} text-${state} fw-bold`}
                      style={{ fontSize: '4rem' }}
                    >
                      {label}
                    </span>
                  </div>
                </div>
                <div className='mt-3'>
                  <h4>{data?.getUserById?.name}</h4>
                  <p className='text-muted mb-1'>ID - {data?.getUserById?.id}</p>
                  <p className='text-muted fs-5'>{data?.getUserById?.email}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-8'>
          <div className='card mb-3'>
            <div className='card-body'>
              <div className='row'>
                <div className='col-sm-3'>
                  <h6 className='mb-0'>Full Name</h6>
                </div>
                <div className='col-sm-9 text-muted'>{data?.getUserById?.name}</div>
              </div>
              <hr style={{ color: '#a1a5b7' }}></hr>
              <div className='row'>
                <div className='col-sm-3'>
                  <h6 className='mb-0'>Email</h6>
                </div>
                <div className='col-sm-9 text-muted'>{data?.getUserById?.email}</div>
              </div>
              <hr style={{ color: '#a1a5b7' }}></hr>
              <div className='row'>
                <div className='col-sm-3'>
                  <h6 className='mb-0'>Department</h6>
                </div>
                <div className='col-sm-9 text-muted'>
                  {data?.getUserById?.Department || 'Not logged Yet'}
                </div>
              </div>
              <hr style={{ color: '#a1a5b7' }}></hr>
              <div className='row'>
                <div className='col-sm-3'>
                  <h6 className='mb-0'>Team</h6>
                </div>
                <div className='col-sm-9 text-muted'>{data?.getUserById?.teamId}</div>
              </div>
              <hr style={{ color: '#a1a5b7' }}></hr>
              <div className='row'>
                <div className='col-sm-12'>
                  <button className='btn btn-primary ' onClick={openModal}>
                    Edit
                  </button>
                  <ReactModal
                    isOpen={isModalOpen}
                    onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal}
                    style={customModalStyles}
                    contentLabel='Edit Personal Details'
                  >
                    <EditAgentOperatorProfile data={data} closeModal={closeModal} />
                  </ReactModal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AgentOperatorProfilePage
